import moment from 'moment'

export const API_FULL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ'

export const nextBusinessDay = date => {
  if (date.isoWeekday() > 5) {
    date.add(8 % date.isoWeekday(), 'days')
  }
  return date
}

export const withinDays = (date, numDays) =>
  !!date && moment(date).isSameOrAfter(moment().subtract(numDays, 'day'))
